///<reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/bootstrap.multiselect.d.ts"/>
import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { InstallationAssetComponent } from './installationAsset.component';
import { PopupComponent } from '../ReviewEmployee/PopUp.component';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
declare var $: any;

@Component({
    templateUrl: './AppViews/Warranty/installationAdd.html'
})

export class InstallationAddComponent implements OnInit {
    constants: Constants;
    installationDetails: any = {};
    userDetail: any;
    public showLoader = false;
    public showPanel = false;
    addEditIR: any = { IRId: 0, InstallById: 0, CustomerId: "", ProjectId: "", StatusId: "", VendorId: 0 };
    projectListMain: any = [];
    projectList: any = [];
    customerList: any = [];
    installationTypeList: any = [];
    irStatusList: any = [];
    installByList: any = [];
    vendorList: any = [];
    public isFormSubmitted: boolean = false;
    public EnableData: boolean = false;
    public IsExecutive: boolean = false;
    public canEditAsset: boolean = false;
    public canRemoveAsset: boolean = false;
    selectedFileName: any;
    fileList: any = [];
    docsList: any = [];
    reportDocList: any = [];
    projectId: any = "";
    customerId: any = "";

    selectedFileName1: any;
    fileList1: any = [];
    myDocsFile: any = false;
    docList1: any;
    selectedReportDocList: any = [];
    selectedImageDocList: any = [];
    irIdNew: any;

    canvasOffset: any;
    clickX: any[];
    clickDrag: any[];
    paint: any;
    clickY: any[];
    isSignature: any;
    @ViewChild('sigPad') sigPad;
    sigPadElement;
    context;
    isDrawing = false;
    img;
    private cx: CanvasRenderingContext2D;
    docURL: any = "";
    AssetCount: any = 0;

    safeDocUrl: SafeUrl;

    //drivePath = "../../assets/img/nocontent.png";

    docName: any;
    docItem = {
        DocName: null,
        FolderPath: null
    }
    imageType: any;
    isInitData = false;
    IsReportTab: boolean = false;
    isFromInstallation: boolean = false;
    vendorNameErr: boolean = false;
    vendorNoErr: boolean = false;
    installByErr: boolean = false;
    isThirdTab: boolean = false;

    @ViewChild(InstallationAssetComponent) assetChild;
    @ViewChild(PopupComponent) DocChild;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe, private route: ActivatedRoute, private _route: Router, public sanitizer: DomSanitizer) {
        this.route.params.subscribe(
            data => {
                this.addEditIR.IRId = data["irId"];
            }
        );
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.projectId = JSON.parse(localStorage.getItem("ProjectId"));
        this.customerId = JSON.parse(localStorage.getItem("CustomerId"));
        this.addEditIR.InstallById = 0;
        if (this.projectId > 0 && this.customerId > 0) {
            this.addEditIR.ProjectId = this.projectId;
            this.addEditIR.CustomerId = this.customerId;
        }
        else{
            if( typeof this.addEditIR.IRId=='undefined'){
                this._route.navigateByUrl("/projectList");
            }
        }
        localStorage.removeItem("ProjectId");
        localStorage.removeItem("CustomerId");
        
        if (this.addEditIR.IRId > 0) {
            this.GetIRDataForEdit();
            this.showPanel = true;
        }
    }

    ngOnInit() {
        this.showLoader = true;
        this.isFromInstallation = JSON.parse(localStorage.getItem('IsFromInstallation'));
        this.GetProjectList();
        this.GetInstallationType();
        this.GetInstallationStatus();
        this.GetVendorsList();
        this.GetDocsList();
        if (this.userDetail.RoleId == this.constants.enumUserRole.Executive || this.userDetail.RoleId == this.constants.enumUserRole.Vendor) {
            // setTimeout(() => {
            //     $("#collapse3").addClass("hide");
            // }, 200);
            // this.toggleAccordian(3);
            this.IsExecutive = true;
        }
        else {
            this.IsExecutive = false;
            if (!this.isFromInstallation && (this.addEditIR.IRId == 0 || this.addEditIR.IRId == null || this.addEditIR.IRId == 'undefined' || this.addEditIR.IRId == '')) {
                this.CreateInstallationRequest();
            }
            else {
                
                // setTimeout(() => {
                //     $("#collapse1").addClass("hide");
                // }, 200);
                //this.toggleAccordian(1);
            }
        }
        this.showLoader = false;
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        // this.isFormSubmitted = false;
    }

    ngAfterViewInit() {
        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });

        $('.IDate').datetimepicker({
            format: 'DD/MM/YYYY',
            maxDate: moment()
        });
    }

    ngAfterViewChecked() {
        if (this.projectList.length > 0) {
            $('.dataSearch').selectpicker({
                style: 'btn-info',
                size: 4
            });

            $('.selectPicker').selectpicker({ style: 'btn-info' });
        }
    }

    CancelAsset() {
        this.assetChild.addAssetForm.reset();
        this.assetChild.startDateErr = false;
        this.assetChild.endDateErr = false;
        this.assetChild.invalidEndDate = false;
    }

    GetIRDataForEdit() {
        this.showLoader = true;
        this._httpService.ajaxPost("InstallationRequest/GetInstallationRequest",
            { "IRId": this.addEditIR.IRId, "ProjectId": 0, "CustomerId": 0, "Status": 0, "LoginUserId": this.userDetail.SiteUserId }).subscribe(
                data => {
                    this.addEditIR = data["IRList"][0];
                    this.addEditIR.InstallById = this.addEditIR.InstallById != null ? this.addEditIR.InstallById : 0;
                    this.addEditIR.VendorId = this.addEditIR.VendorId != null ? this.addEditIR.VendorId : 0;

                    var docList = data["IRDocList"];
                    if (docList != null && docList.length > 0) {
                        this.addEditIR.FileDocList = docList;
                        this.selectedReportDocList = docList.filter(z => z.FileDocType == this.constants.FileType.IRReport);
                        this.selectedImageDocList = docList.filter(z => z.FileDocType == this.constants.FileType.IRImage);
                    }
                    if (this.addEditIR.InstallationType == this.constants.InstallationType.Vendor) {
                        this.GetVendorUserList(0);
                    }
                    else {
                        this.GetInstallByList();
                    }
                    if (!this.addEditIR.CanEditIR) {
                        this.EnableData = true;
                        this.canEditAsset = false;
                        this.canRemoveAsset = false;
                    }
                    else {
                        if (this.addEditIR.StatusId == this.constants.IRStatus.Draft)
                        {
                            this.EnableData = false;
                            this.canEditAsset = true;
                            this.canRemoveAsset = true;
                            //Set some default values for first time load
                            this.addEditIR.LocationCity = 'Mumbai';
                            this.addEditIR.InstallById = 0;
                        }
                        if (this.addEditIR.StatusId == this.constants.IRStatus.Assigned) {
                            this.EnableData = false;
                            this.canEditAsset = true;
                            this.canRemoveAsset = true;
                        }
                        else if (this.addEditIR.StatusId == this.constants.IRStatus.InProgress || this.addEditIR.StatusId == this.constants.IRStatus.Locked) {
                            this.EnableData = true;
                            this.canEditAsset = true;
                            this.canRemoveAsset = true;
                        }
                        else if (this.addEditIR.StatusId == this.constants.IRStatus.Completed) {
                            this.EnableData = true;
                            this.canRemoveAsset = false;

                            //Mark complted
                             if (!$('#IsCompleted').is(':checked')) {
                                $("#IsCompleted").attr('checked', true).trigger('click');
                             }

                            if (this.userDetail.RoleId == this.constants.enumUserRole.Manager
                                || this.userDetail.RoleId == this.constants.enumUserRole.SysAdmin
                                || this.userDetail.RoleId == this.constants.enumUserRole.Admin
                            ) {
                                this.canEditAsset = true;
                                this.EnableData = false;

                            }
                        }
                    }

                    this.assetChild.irID = this.addEditIR.IRId;
                    this.assetChild.EnableData = this.EnableData;
                    this.assetChild.canEditAsset = this.canEditAsset;
                    this.assetChild.canRemoveAsset = this.canRemoveAsset;
                    this.assetChild.projectId = this.addEditIR.ProjectId;
                    this.assetChild.GetAssetList();
                    this.assetChild.GetAssetListForDropdown();

                    if (this.addEditIR.StatusId == this.constants.IRStatus.Assigned ||
                        this.addEditIR.StatusId == this.constants.IRStatus.Completed ||
                        this.addEditIR.StatusId == this.constants.IRStatus.Locked) {
                        if (this.addEditIR.AssetCount > 0) {
                            setTimeout(() => {
                                $("#collapse3").addClass("hide");
                            }, 200);
                            this.toggleAccordian(3);
                        }
                        else{
                            setTimeout(() => {
                                $("#collapse2").addClass("hide");
                            }, 200);
                            this.toggleAccordian(2);
                        }
                    }
                    else{
                        setTimeout(() => {
                            $("#collapse1").addClass("hide");
                        }, 200);
                        this.toggleAccordian(1);
                    }


                },
                err => {
                    console.log("GetProjectList Failed");
                    this.showLoader = false;
                },
                () => {
                    this.showLoader = false;
                }
            );
    }


    DeleteIRDoc(item: any): any {
        this.showLoader = true;
        this._httpService.ajaxPost('InstallationRequest/DeleteIRDoc', { IRId: item.IRId, FileDocId: item.FileDocId }).subscribe(
            data => {

                this.showLoader = false;
                var msg = data["Status"].Message.split('|');
                if (msg.length >= 1) {

                    msg[0] = msg[0].toLowerCase();
                    if (msg[0] == "success") {
                        var docList = data["IRDocList"];
                        if (docList != null && docList.length > 0) {
                            this.addEditIR.FileDocList = docList;
                            this.selectedReportDocList = docList.filter(z => z.FileDocType == this.constants.FileType.IRReport);
                            this.selectedImageDocList = docList.filter(z => z.FileDocType == this.constants.FileType.IRImage);
                        }
                        this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                    }
                    else if (msg[0] == "warning") {
                        this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                    }
                    else {
                        this._sharedService.ShowMessage(this.constants.globalError);
                    }
                }
                else {
                }
            },
            () => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            });
    }

    GetDocsList() {
        this.showLoader = true;
        this._httpService.ajaxPost("InstallationRequest/GetInstalationDocsFromSalespro",
            { "IRId": this.addEditIR.IRId }).subscribe(
                data => {
                    this.docsList = data["IRSList"];
                    console.log(data);
                },
                err => {
                    console.log("GetAssetList Failed");
                    this.showLoader = false;
                },
                () => {
                    this.showLoader = false;
                }
            );
    }


    GetProjectList() {
        this._httpService.ajaxPost("InstallationRequest/GetProjectIR",
            { "ProjectId": 0, "ProjectType": this.constants.projectType.HWInstallation, "Status": 1, "CustomerId": 0, "IsListFilter": false, "LoginUserId": this.userDetail.SiteUserId }).subscribe(
                data => {
                    this.customerList = data["CustomerList"];
                    this.projectListMain = data["ProjectList"];
                    if (this.addEditIR.CustomerId > 0 && this.projectListMain != null && this.projectListMain.length > 0) {
                        this.projectList = this.projectListMain.filter(x => x.Customer_Id == this.addEditIR.CustomerId);
                    }

                },
                err => {
                    console.log("GetProjectList Failed");
                },
                () => {
                }
            );
    }

    GetInstallationType() {
        this._httpService.ajaxPost("Common/GetParameter", { "ParameterTypeId": this.constants.enumParamterTypeName.InstallationType }).subscribe(
            data => {
                this.installationTypeList = data["Parameter"];

            },
            err => {
                console.log("GetParameter Failed");
            },
            () => {
            }
        );
    }

    GetInstallationStatus() {
        this._httpService.ajaxPost("Common/GetParameter", { "ParameterTypeId": this.constants.enumParamterTypeName.IRStatus }).subscribe(
            data => {
                this.irStatusList = data["Parameter"];

            },
            err => {
                console.log("GetParameter Failed");
            },
            () => {
            }
        );
    }

    onCustomerChange(customerId) {
        if (customerId > 0 && this.projectListMain != null && this.projectListMain.length > 0) {
            this.projectList = this.projectListMain.filter(x => x.Customer_Id == customerId);
        }
    }

    GetVendorsList() {
        this._httpService.ajaxPost('Vendors/GetVendors', {
            "VendorId": 0,
            "IsActive": ""
        }).subscribe(
            data => {
                this.vendorList = data["Vendors"];
            },
            err => {
                this._sharedService.ShowMessage(this.constants.globalError);

            },
            () => {
            }
        );
    }

    GetInstallByList() {
        this._httpService.ajaxPost("InstallationRequest/GetInstallByList",
            { "UserId": this.userDetail.SiteUserId }).subscribe(
                data => {
                    this.installByList = data["InstallByList"];
                },
                err => {
                    console.log("GetInstallByList Failed");
                },
                () => {
                }
            );
    }

    GetInstallByListAssignForIntitialLoad() {
        this._httpService.ajaxPost("InstallationRequest/GetInstallByList",
            { "UserId": this.userDetail.SiteUserId }).subscribe(
                data => {
                    this.installByList = data["InstallByList"];

                    if(this.installByList.length>0){
                        //Check assigned user is available for logged in user
                        let checkUserAvailable= this.installByList.filter(x=>x.SiteUser_Id==this.addEditIR.AssignedToId);
                        if(checkUserAvailable.length==0)
                            this.addEditIR.InstallById =0;
                    }
                },
                err => {
                    console.log("GetInstallByList Failed");
                },
                () => {
                }
            );
    }


    GetVendorUserList(value) {
        this._httpService.ajaxPost("InstallationRequest/GetVendorUserList",
            { "VendorId": value }).subscribe(
                data => {
                    this.installByList = data["VendorList"];
                },
                err => {
                    console.log("GetInstallByList Failed");
                },
                () => {
                }
            );
    }

    GetIRList(val) {
        this._httpService.ajaxPost("InstallationRequest/GetInstallationRequest",
            { "IRId": 0, "ProjectId": val, "CustomerId": 0, "Status": 0, "LoginUserId": this.userDetail.SiteUserId }).subscribe(
                data => {
                    this.addEditIR = data["IRList"][0];
                    if (this.addEditIR.IRId > 0) {
                        if (this.addEditIR.InstallationType == this.constants.InstallationType.Vendor) {
                            this.GetVendorUserList(0);
                        }
                        else {
                            this.GetInstallByList();
                        }

                    }
                },
                err => {
                    console.log("GetProjectList Failed");
                },
                () => {
                }
            );
    }


    GetIRData(val) {
        this._httpService.ajaxPost("InstallationRequest/GetIRFromSalespro",
            { "IRSPId": 0, "ProjectId": val }).subscribe(
                data => {
                    var dataObj = data["IRSList"];
                    if (dataObj.length > 0) {
                        this.addEditIR = dataObj[0];
                        this.addEditIR.InstallById = this.addEditIR.InstallById != null ? this.addEditIR.InstallById : 0;
                        this.addEditIR.VendorId = this.addEditIR.VendorId != null ? this.addEditIR.VendorId : 0;
                        
                        //Set some default values for first time load
                        this.addEditIR.LocationCity = 'Mumbai';
                        this.addEditIR.InstallById = this.addEditIR.AssignedToId;
                        this.addEditIR.AssignedToName = this.addEditIR.AssignedTo;

                        this.addEditIR.IRId = this.irIdNew;
                        if (this.addEditIR.IRId > 0) {
                            if (this.addEditIR.InstallationType == this.constants.InstallationType.Vendor) {
                                this.GetVendorUserList(0);
                            }
                            else {
                                this.GetInstallByListAssignForIntitialLoad();
                            }
                        }

                        this.assetChild.irID = this.addEditIR.IRId;
                        this.assetChild.projectId = this.addEditIR.ProjectId;
                        this.assetChild.GetAssetList();
                        this.assetChild.GetAssetListForDropdown();
                    }
                },
                err => {
                    console.log("GetProjectList Failed");
                },
                () => {
                }
            );
    }

    onVendorUserChange(val) {
        if (this.addEditIR.InstallationType == this.constants.InstallationType.Vendor) {
            this.addEditIR.InstallById = 0;
            var userData = this.installByList.filter(x => x.SiteUser_Id == val);
            if (userData != null) {
                this.addEditIR.VendorContactName = userData[0].Name;
            }
        }
    }

    onInstallationTypeChange(value) {
        if (value == this.constants.InstallationType.Swan) {
            this.GetInstallByList();
            this.addEditIR.InstallById = 0;
        }
        else {
            this.GetVendorUserList(0);
            this.addEditIR.InstallById = 0;
            this.addEditIR.VendorId = 0;
        }
    }

    public addUpdateTab(form: any) {
        if(this.addEditIR.IsCompleted == true) {
            if(this.reportDocList.length == 0) {
                this.myDocsFile = true;
                return
            }
        }

        this.isFormSubmitted = true;
        this.vendorNameErr = false;
        this.vendorNoErr = false;
        this.installByErr = false;

        if (this.reportDocList != null && this.reportDocList.length > 0) {
            this.addEditIR.FileDocList = this.reportDocList;
        }
        if (this.addEditIR.InstallationType == this.constants.InstallationType.Swan) {
            //if (this.addEditIR.StatusId != this.constants.IRStatus.Draft) {
                if (this.addEditIR.InstallById <= 0 || this.addEditIR.InstallById == null) {
                    this.installByErr = true;
                }
            //}
        }
        else {
            if (this.addEditIR.VendorContactName == '' || this.addEditIR.VendorContactName == null) {
                this.vendorNameErr = true;
            }
            if (this.addEditIR.VendorContactNo == '' || this.addEditIR.VendorContactNo == null) {
                this.vendorNoErr = true;
            }
        }

        if (form.form.valid && !this.vendorNameErr && !this.vendorNoErr && !this.installByErr) {
            this.showLoader = true;
            var oldStatus = this.addEditIR.StatusId;

            if (this.addEditIR.InstallationType == this.constants.InstallationType.Vendor &&
                this.addEditIR.VendorContactName != null) {
                this.addEditIR.StatusId = this.constants.IRStatus.Assigned;
            }

            if (this.addEditIR.InstallById > 0) {
                this.addEditIR.StatusId = this.constants.IRStatus.Assigned;
            }
            if (this.addEditIR.IsCompleted > 0) {
                this.addEditIR.StatusId = this.constants.IRStatus.Completed;
            }
            this.addEditIR.CreatedBy = this.userDetail.SiteUserId;
            this._httpService.ajaxPost('InstallationRequest/AddUpdateIR', this.addEditIR).subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                    if (msg.length >= 1) {

                        msg[0] = msg[0].toLowerCase();
                        if (msg[0] == "success") {
                            this.GetIRDataForEdit();
                            this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                            if (this.IsReportTab)
                                this.RedirectToList();
                        }
                        else if (msg[0] == "warning") {
                            this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                        }
                        else {
                            this._sharedService.ShowMessage(this.constants.globalError);
                        }
                    }
                    else {
                    }
                },
                err => {
                    this.showLoader = false;
                    this.addEditIR.StatusId = oldStatus;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },

                () => {
                    this.showLoader = false;
                }
            );
        }
    }


    public CreateInstallationRequest() {
        this._httpService.ajaxPost('InstallationRequest/CreateInstallationRequest', { "ProjectId": this.addEditIR.ProjectId, "CreatedBy": this.userDetail.SiteUserId }).subscribe(
            data => {

                var msg = data["Status"].Message.split('|');
                if (msg.length >= 1) {

                    msg[0] = msg[0].toLowerCase();
                    if (msg[0] == "success") {
                        this.GetIRData(this.addEditIR.ProjectId);
                        this.irIdNew = data["IRId"];
                        this.showPanel = true;
                        setTimeout(() => {
                            $("#collapse1").addClass("hide");
                        }, 200);
                        this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                        this.toggleAccordian(1);
                    }
                    else if (msg[0] == "warning") {
                        this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                    }
                    else {
                        this._sharedService.ShowMessage(this.constants.globalError);
                    }
                }
                else {
                }
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
        );
    }



    onChangeFileInput(event) {

        let fileList: FileList = event.target.files;
        if(fileList.length != 0) {
            this.myDocsFile = false;
        }
        this.selectedFileName = "";
        for (var i = 0; i < fileList.length; i++) {
            var lastThree = fileList[i].name.substr(fileList[i].name.length - 3);
            var lastFour = fileList[i].name.substr(fileList[i].name.length - 4);

            if (lastThree.toLowerCase() != 'pdf' && lastThree.toLowerCase() != 'eml' && lastThree.toLowerCase() != 'jpg' && lastThree.toLowerCase() != 'png' && lastFour.toLowerCase() != 'docx' && lastFour.toLowerCase() != 'jpeg'
                && lastThree.toLowerCase() != 'xls' && lastFour.toLowerCase() != 'xlsx' && lastFour.toLowerCase() != 'xlsm' && lastThree.toLowerCase() != 'msg') {
                this._sharedService.ShowMessage('error|Please use .pdf, .eml, .jpg, .jpeg, .png, .docx, .xls, .xlsx, .xlsm, .msg file');
                $('#reportfile').val('');
                return;
            }
            if (fileList[i].size > 10485760)//2MB:2097152,10MB
            {
                this._sharedService.ShowMessage('error|Maximum size should be 10MB.');
                $('#reportfile').val('');
                return;
            }
            if (fileList.length - 1 == i)
                this.selectedFileName = this.selectedFileName + fileList[i].name;
            else
                this.selectedFileName = this.selectedFileName + fileList[i].name + ", ";
        }
        if (fileList.length > 0) {
            this.fileList = fileList;

        }
    }

    onChangeFileInput1(event) {

        let fileList: FileList = event.target.files;
        this.selectedFileName1 = "";
        for (var i = 0; i < fileList.length; i++) {
            var lastThree = fileList[i].name.substr(fileList[i].name.length - 3);
            var lastFour = fileList[i].name.substr(fileList[i].name.length - 4);

            if (lastThree.toLowerCase() != 'pdf' && lastThree.toLowerCase() != 'eml' && lastThree.toLowerCase() != 'jpg' && lastThree.toLowerCase() != 'png' && lastFour.toLowerCase() != 'docx' && lastFour.toLowerCase() != 'jpeg'
                && lastThree.toLowerCase() != 'xls' && lastFour.toLowerCase() != 'xlsx' && lastFour.toLowerCase() != 'xlsm' && lastThree.toLowerCase() != 'msg') {
                this._sharedService.ShowMessage('error|Please use .pdf, .eml, .jpg, .jpeg, .png, .docx, .xls, .xlsx, .xlsm, .msg file');
                $('#reportfile').val('');
                return;
            }
            if (fileList[i].size > 10485760)//2MB:2097152,10MB
            {
                this._sharedService.ShowMessage('error|Maximum size should be 10MB.');
                $('#reportfile').val('');
                return;
            }
            if (fileList.length - 1 == i)
                this.selectedFileName1 = this.selectedFileName1 + fileList[i].name;
            else
                this.selectedFileName1 = this.selectedFileName1 + fileList[i].name + ", ";
        }
        if (fileList.length > 0) {
            this.fileList1 = fileList;
            this.uploadImageDocs();
        }
    }


    uploadReportDocs(form: any) {
        this.isFormSubmitted = true;
        this.IsReportTab = true;
        this.isThirdTab=true;
        if (form.form.valid) {
            this.showLoader = true;
            if ($('#reportfile').val() != null && $('#reportfile').val() != "" && $('#reportfile').val() != undefined) {
                var params = {
                    IRId: this.addEditIR.IRId,
                    FileType: this.constants.FileType.IRReport
                }
                var fileList = this.fileList;
                if (this.fileList1 != null && this.fileList1.length > 0) {
                    for (let index = 0; index < this.fileList1.length; index++) {
                        fileList.push(new File(this.fileList1[index].Content, this.fileList1[index].Name));
                    }
                }

                var countOfUploadList = this.fileList.length;
                if (countOfUploadList <= 100) {
                    this._httpService.ajaxPostFileList("InstallationRequest/UploadInstallationReport", fileList, params).then((response) => {
                        $('#reportfile').val('');
                        if (response.DocList != null && response.DocList.length > 0) {
                            response.DocList.forEach(element => {
                                this.reportDocList.push(element);
                            });

                            if (this.reportDocList != null && this.reportDocList.length > 0) {
                                this.addEditIR.FileDocList = this.reportDocList;
                            }
                            this.addUpdateTab(form)
                            $('#reportfile').val('');
                            $('#reportfile1').val('');
                        }
                    }, () => {
                        this.showLoader = false;
                        this._sharedService.ShowMessage(this.constants.globalError);
                    });
                }
                else {
                    $('#reportfile').val('');
                    this._sharedService.ShowMessage('error|only 20 files allowed to upload.');

                    this.showLoader = false;
                }
            }
            else {

                if (this.reportDocList != null && this.reportDocList.length > 0) {
                    this.addEditIR.FileDocList = this.reportDocList;
                }
                this.addUpdateTab(form)
            }
        }
    }

    uploadImageDocs() {

        this.showLoader = true;
        if ($('#reportfile1').val() != null && $('#reportfile1').val() != "" && $('#reportfile1').val() != undefined) {
            var params = {
                IRId: this.addEditIR.IRId,
                FileType: this.constants.FileType.IRImage
            }
            var countOfUploadList = this.fileList.length;
            if (countOfUploadList <= 100) {
                this._httpService.ajaxPostFileList("InstallationRequest/UploadInstallationReport", this.fileList1, params).then((response) => {
                    $('#reportfile1').val('');
                    if (response.DocList != null && response.DocList.length > 0) {
                        response.DocList.forEach(element => {
                            this.reportDocList.push(element);
                        });
                    }
                }, () => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                });
            }
            else {
                $('#reportfile1').val('');
                this._sharedService.ShowMessage('error|only 20 files allowed to upload.');

                this.showLoader = false;
            }
        }
        else {
            //this.onClickSaveJob();
        }

    }




    toggleAccordian(index) {
        $("html").animate({ scrollTop: 0 }, "fast");
        this.showLoader = true;
        setTimeout(() => {
            if (($('#collapse' + index).hasClass('show'))) {
                $('.collapse').removeClass('show');
            }
            else {
                $('.collapse').removeClass('show');
                $('#collapse' + index).addClass('show');

            }

            $('.date').datetimepicker({
                format: 'DD/MM/YYYY'
            });

            $('.IDate').datetimepicker({
                format: 'DD/MM/YYYY',
                maxDate: moment()
            });

            this.showLoader = false;
        }, 500);

    }



    @HostListener('document:mouseup', ['$event'])

    onMouseUp(e) {

        this.mouseUp()
    }

    onMouseDown(e) {
        this.mouseDown(e)

    }

    onMouseMove(e) {
        this.mouseXY(e)

    }


    clear() {
        this.clickX = new Array();
        this.clickY = new Array();
        this.clickDrag = new Array();
        this.context.clearRect(0, 0, this.sigPadElement.width, this.sigPadElement.height);
        this.context.beginPath();
    }

    draw() {

        this.context.strokeStyle = "#000000";  //set the "ink" color
        this.context.lineJoin = "miter";       //line join
        this.context.lineWidth = 2;            //"ink" width

        for (var i = 0; i < this.clickX.length; i++) {
            this.context.beginPath();                               //create a path
            if (this.clickDrag[i] && i) {
                this.context.moveTo(this.clickX[i - 1], this.clickY[i - 1]);  //move to
            } else {
                this.context.moveTo(this.clickX[i] - 1, this.clickY[i]);      //move to
            }
            this.context.lineTo(this.clickX[i], this.clickY[i]);              //draw a line
            this.context.stroke();                                  //filled with "ink"
            this.context.closePath();                               //close path
        }

    }


    addClick(x, y, dragging) {
        this.clickX.push(x);
        this.clickY.push(y);
        this.clickDrag.push(dragging);
    }

    mouseXY(e) {
        // if(this.isSignature){
        const bounds = e.target.getBoundingClientRect();

        if (this.paint) {
            if (e.pageX != null && e.pageY != null) {
                this.addClick(e.pageX - bounds.left, e.pageY - bounds.top, true);
                this.draw();
            }
        }
        //}
    }

    touchXY(e) {
        //  if(this.isSignature){
        e.preventDefault();
        const bounds = e.target.getBoundingClientRect();

        var touch = e.targetTouches[0];
        if (this.paint) {
            if (touch.pageX != null && touch.pageY != null) {
                this.addClick(touch.pageX - bounds.left, touch.pageY - bounds.top, true);
                this.draw();
            }
        }
        //}
    }

    mouseUp() {
        // if(this.isSignature){
        this.paint = false;
        //  }
    }

    mouseDown(e) {
        //  if(this.isSignature){
        const bounds = e.target.getBoundingClientRect();
        var mouseX = e.pageX - bounds.left;
        var mouseY = e.pageY - bounds.top;

        this.paint = true;
        if (e.pageX != null && e.pageY != null) {
            this.addClick(e.pageX - bounds.left, e.pageY - bounds.top, false);
            this.draw();
        }
        // }
    }


    touchDown(e) {
        //  if(this.isSignature){
        const bounds = e.target.getBoundingClientRect();
        var mouseX = e.pageX - bounds.left;
        var mouseY = e.pageY - bounds.top;

        var touch = e.targetTouches[0];
        this.paint = true;

        if (touch.pageX != null && touch.pageY != null) {
            this.addClick(touch.pageX - bounds.left, touch.pageY - bounds.top, false);
            this.draw();
        }
    }


    AddSignature() {
        $("html").animate({ scrollTop: 0 }, "fast");
        $('#addSignature').modal('show');

        setTimeout(() => {
            // $('#schedule-modal').modal('show');
            //  const scrollDemo = document.querySelector("html");
            this.sigPadElement = this.sigPad.nativeElement;
            this.context = this.sigPadElement.getContext('2d');
            this.context.strokeStyle = "#000000"
            this.sigPadElement.width = this.sigPadElement.offsetWidth;
            this.sigPadElement.height = this.sigPadElement.offsetHeight;
            this.clickX = new Array();
            this.clickY = new Array();
            this.clickDrag = new Array();
            this.paint;
            var scope = this;
            var el = document.getElementById("canvas");
            el.addEventListener("touchstart", (e) => {

                const bounds = el.getBoundingClientRect();

                var touch = e.targetTouches[0];
                scope.paint = true;

                if (touch.pageX != null && touch.pageY != null) {
                    scope.addClick(touch.pageX - bounds.left, touch.pageY - bounds.top, false);
                    scope.draw();
                }

            });
            el.addEventListener("touchend", (e) => {

                scope.paint = false;


            });
            el.addEventListener("touchcancel", (e) => {

                scope.paint = false;


            });
            el.addEventListener("touchmove", (e) => {


                e.preventDefault();
                const bounds = el.getBoundingClientRect();
                var touch = e.targetTouches[0];
                if (scope.paint) {
                    if (touch.pageX != null && touch.pageY != null) {
                        scope.addClick(touch.pageX - bounds.left, touch.pageY - bounds.top, true);
                        scope.draw();
                    }
                }


            });


        }, 500);
    }

    submitSignature() {
        this.addEditIR.customerSignature = this.sigPadElement.toDataURL("image/png");
        $('#addSignature').modal('hide');
    }
    // }

    openDoc(val) {
        this.showDoc(val);
        $('#ViewScreanShot').modal('show');
    }


    showDoc(item) {
debugger;
        this.isInitData = true;

        this.imageType = null;
        this.docItem.DocName = null;
        // this.docItem.FolderPath = "../../assets/img/nocontent.png";
        // this.drivePath = "../../assets/img/nocontent.png";

        if (item != null) {
            this.docItem = JSON.parse(JSON.stringify(item));

            if (this.docItem.FolderPath == null || this.docItem.FolderPath == "") {
                // this.docItem.FolderPath = "../../assets/img/nocontent.png";
            }

            this.getFileType();
            this.docName = item.DocName;
        }
    }

    getFileType() {

        if (this.docItem.DocName != null && this.docItem.DocName != "") {
            var iName = this.docItem.DocName.split(".");
            if (iName.length > 0 && iName.length - 1 != null)
                this.imageType = iName[iName.length - 1].toLowerCase();
        }


        if (this.imageType != 'jpg' && this.imageType != 'png' && this.imageType != 'jpeg' && this.imageType != 'msg') {
            var docpath = "https://docs.google.com/viewer?url=" + this.docItem.FolderPath + "&embedded=true";
            //  var docpath = this.docItem.FolderPath;


            var safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(JSON.parse(JSON.stringify(docpath)));

            this.safeDocUrl = safeUrl;

        } else {

        }


    }


    public RedirectToList() {
        this.isFromInstallation = JSON.parse(localStorage.getItem('IsFromInstallation'));
        if (this.isFromInstallation == true)
            this._route.navigate(["/installation"]);
        else
            this._route.navigate(["/projects", { projectId: this.addEditIR.ProjectId, Com: 0 }]);
    }

    public RedirectToProject() {
        this._route.navigate(["/projects", { projectId: this.addEditIR.ProjectId, Com: 0 }]);
    }

    SetCompletedStatus() {
        if (this.addEditIR.CustomerContactName.length > 0) {
            this.addEditIR.IsCompleted = true;
            if (!$('#IsCompleted').is(':checked')) {
                $("#IsCompleted").attr('checked', true).trigger('click');
            }
        }
    }

    reloadIRAdd(){
        this.GetIRDataForEdit();
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Warranty/installationAdd.component.ts
 **/